import API from "./../../api";

export default () => {
    return API.get("api/cohort-builder/config")
}
